<ccc-cca-user-logged-in></ccc-cca-user-logged-in>

<div class="container-fluid" [class.sidebar-hide]="navigationStore.toggled.getValue()">
  <div class="row">
    <div class="toggle-menu" ccc-navigation-button-toggle></div>
    <ng-content></ng-content>
    <main class="page-body pt-3 ps-3">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
